import { render, staticRenderFns } from "./PaymentsDetails.vue?vue&type=template&id=14ac57fe&scoped=true"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentsDetails.vue?vue&type=style&index=0&id=14ac57fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ac57fe",
  null
  
)

export default component.exports